module.exports = {
    props: ['user', 'team', 'billableType', 'defaultRole'],

    /**
     * The component's data.
     */
    data() {
        return {
            plans: [],

            roles: [],

            form: new SparkForm({
                email: '',
                name: '',
                role: this.defaultRole,
                invitationSent: false,
                registering: false,
                sendingInvitation: false,
                userExist: 0,
                resendingInvitation: false,
            }),
            activeMemberArray: [],
            teamData: this.team
        };
    },


    computed: {
        /**
         * Get the active subscription instance.
         */
        activeSubscription() {
            if ( ! this.billable) {
                return;
            }

            const subscription = _.find(
                this.billable.subscriptions,
                subscription => subscription.name === 'default'
            );

            if (typeof subscription !== 'undefined') {
                return subscription;
            }
        },


        /**
         * Get the active plan instance.
         */
        activePlan() {
            if (this.activeSubscription) {
                return _.find(this.plans, (plan) => {
                    return plan.id === this.activeSubscription.provider_plan;
                });
            }
        },


        /**
         * Check if there's a limit for the number of team members.
         */
        hasTeamMembersLimit() {
            if (! this.activePlan) {
                return false;
            }

            return !! this.activePlan.attributes.teamMembers;
        },


        /**
         *
         * Get the remaining team members in the active plan.
         */
        remainingTeamMembers() {
            return this.activePlan
                    ? this.activePlan.attributes.teamMembers - this.$parent.team.users.length
                    : 0;
        },


        /**
         * Check if the user can invite more team members.
         */
        canInviteMoreTeamMembers() {
            if (! this.hasTeamMembersLimit) {
                return true;
            }

            return this.remainingTeamMembers > 0;
        },
        /**
         * Check if the registered user and invites reached the limit of 3 then disable the buttons.
         */
        canInviteOrRegisterFreeTrialUsers() {
            let usersCount = this.$parent.team.users.length;
            const userEmails = this.$parent.team.users.map(user => (user.email))

            if(this.$parent.invitations.length > 0) {
                this.$parent.invitations.map(invitation => {
                    if(!userEmails.includes(invitation.email)){
                        usersCount++;
                    }
                })

            }
            return usersCount < 3;
        }
    },


    /**
     * The component has been created by Vue.
     */
    created() {
        this.getPlans();

        this.getRoles();

    },


    methods: {
        /**
         * Send a team invitation.
         */
        send() {

            this.form.sendingInvitation = true;
            Spark.post(`/settings/${Spark.teamsPrefix}/${this.team.id}/invitations`, this.form)
                .then(() => {
                    this.form.email = '';
                    this.form.name = '';
                    this.form.invitationSent = true;
                    this.form.sendingInvitation = false;
                    this.form.role = Spark.defaultRole;

                    this.$parent.$emit('updateInvitations');
                })
                .catch(()=>{
                    this.form.sendingInvitation = false;
                });

        },
        /**
         * Register user without invitation.
         */
        registerUser() {
            this.form.registering = true;
            this.form.userExist = 0;
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });
            this.form.email = this.form.email.trim()


            Spark.post(`/settings/${Spark.teamsPrefix}/${this.team.id}/register`, this.form)
                .then((response) => {
                    if(response.status) {
                        Toast.fire({
                            type: 'success',
                            title: response.message
                        });
                        this.form.email = '';
                        this.form.name = '';
                        this.form.role = this.defaultRole;
                    }else{
                        Toast.fire({
                            type: 'error',
                            title: response.message
                        });
                    }
                    this.form.userExist = response.user_already_exist;
                    this.form.registering = false;

                    this.$parent.$emit('updatePendingInvitations');
                    if(response.status){
                        // window.location.reload();
                    }
                })
                .catch(()=>{
                    this.form.registering = false;
                    this.form.userExist = 0
                });
        },
        resendInvitation() {
            this.form.resendingInvitation = true;
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });

            Spark.post(`/settings/resendPendingInvitations`, this.form)
                .then((response) => {
                    if(response.status) {
                        Toast.fire({
                            type: 'success',
                            title: response.message
                        });
                    }else{
                        Toast.fire({
                            type: 'error',
                            title: response.message
                        });
                    }
                    this.form.resendingInvitation = false;
                    this.form.email = '';
                    this.form.name = '';
                    this.form.role = this.defaultRole;
                    this.form.userExist = 0

                    this.$parent.$emit('updateInvitations');
                })
                .catch(()=>{
                    this.form.resendingInvitation = false;
                    this.form.userExist = 0
                });
        },

        /**
         * Get all the plans defined in the application.
         */
        getPlans() {
            axios.get('/spark/plans')
                .then(response => {
                    this.plans = response.data;
                });
        },

        /**
         * Get the available member roles.
         */
        getRoles() {
            axios.get(`/settings/${Spark.teamsPrefix}/roles`)
                .then(response => {
                    this.roles = response.data;
                });
        },

        showErrorPopup(message){
            Swal.fire({
                icon: 'error',
                text: message,
                type: 'warning',
                showCancelButton: false,
                confirmButtonColor: '#01B1AF',
                confirmButtonText: 'Close'
            }).then((result) => {

            });
        },
        checkAndSendInvite(){
            Spark.post(`/settings/${Spark.teamsPrefix}/${this.team.id}/team-data`, this.form)
                .then((response) => {
                    this.teamData = response;

                let allMembers = response.users;
                let owner = [];
                let systemAdmin = [];
                let admin = [];
                let user = null;
                allMembers.forEach(item => {
                    if (item.pivot.role == 'owner') {
                        owner.push(item);
                    } else if (item.pivot.role == 'admin') {
                        systemAdmin.push(item);
                    } else if (item.pivot.role == 'administrative') {
                        admin.push(item);
                    }
                });

                    response.user_invitation.forEach(invitationItem => {
                    if (invitationItem.role == 'owner') {
                        owner.push(invitationItem);
                    } else if (invitationItem.role == 'admin') {
                        systemAdmin.push(invitationItem);
                    } else if (invitationItem.role == 'administrative') {
                        admin.push(invitationItem);
                    }
                });

                if (this.roles.length > 0) {
                    if ((owner.length > 0 && this.form.role == 'owner')) {
                        let message = '';
                        let roleNumber = '';
                        if (this.form.role == 'owner') {
                            message = 'You can assign the Owner role only to 1 user. Assign another role to the current Owner and try again';
                        }
                /*        if (this.form.role == 'administrative') {
                            message = 'You can assign the Admin role only to 2 users. Assign another role to one of the current Admins and try again';
                        }*/
                        this.showErrorPopup(message);
                        return false;
                    }
                }
                this.send();
            });
        },
        checkAndRegisterUser(){
            Spark.post(`/settings/${Spark.teamsPrefix}/${this.team.id}/team-data`, this.form)
                .then((response) => {
                    this.teamData = response;

                    let allMembers = response.users;
                    let owner = [];
                    let systemAdmin = [];
                    let admin = [];
                    let user = null;
                    allMembers.forEach(item => {
                        if (item.pivot.role == 'owner') {
                            owner.push(item);
                        } else if (item.pivot.role == 'admin') {
                            systemAdmin.push(item);
                        } else if (item.pivot.role == 'administrative') {
                            admin.push(item);
                        }
                    });

                    response.user_invitation.forEach(invitationItem => {
                        if (invitationItem.role == 'owner') {
                            owner.push(invitationItem);
                        } else if (invitationItem.role == 'admin') {
                            systemAdmin.push(invitationItem);
                        } else if (invitationItem.role == 'administrative') {
                            admin.push(invitationItem);
                        }
                    });

                    if (this.roles.length > 0) {
                        if ((owner.length > 0 && this.form.role == 'owner')) {
                            let message = '';
                            let roleNumber = '';
                            if (this.form.role == 'owner') {
                                message = 'You can assign the Owner role only to 1 user. Assign another role to the current Owner and try again';
                            }
                           /* if (this.form.role == 'administrative') {
                                message = 'You can assign the Admin role only to 2 users. Assign another role to one of the current Admins and try again';
                            }*/
                            this.showErrorPopup(message);
                            return false;
                        }
                    }
                    this.registerUser();
                });
        }
    }
};
